<template>
  <v-layout>
    <v-row>
      <v-col class="py-0 my-1">
        <v-card width="100%">
          <div>
            <span v-html="title"></span>
          </div>
          <!-- In Khmer -->
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.schnewKH"
            label="ឈ្មោះសាលារៀន(បច្ចុប្បន្ន)អក្សរខ្មែរ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.schKH"
            label="ឈ្មោះសាលារៀន(ឆ្នាំមុន)អក្សរខ្មែរ"
          />
          <!-- In latin -->
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.schnewENG"
            label="ឈ្មោះសាលារៀន(បច្ចុប្បន្ន)ឡាតាំង"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.schENG"
            label="ឈ្មោះសាលារៀន(ឆ្នាំមុន)ឡាតាំង"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.vilKH"
            label="ភូមិ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.comKH"
            label="ឃុំ/សង្កាត់"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.disKH"
            label="ក្រុង/ស្រុក/ខណ្ឌ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="info.proKH"
            label="រាជធានី/ខេត្ត"
          />
          <v-select
            class="px-1 ttext"
            v-model="info.loc_code"
            :items="loc"
            item-text="text"
            item-value="value"
            outline
            label="ទីតាំងសាលារៀន"
            hide-details
            @keypress.native="onSelect1($event)"
          >
          </v-select>
          <v-select
            class="px-1 ttext"
            v-model="data.nush"
            :items="numShift"
            item-text="text"
            item-value="value"
            outline
            label="ចំនូនវេនរៀន"
            hide-details
            @keypress.native="onSelect2($event)"
          />
          
          <v-select
            class="px-1"
            v-model="data.BDXID"
            :items="yesNo7"
            item-text="text"
            item-value="value"
            outline
            label="សាលារៀនជាប់ព្រំដែនរងផលប៉ះពាល់"
            hide-details
            @keypress.native="onSelect9($event)"
          />
          
          <v-select
            class="px-1"
            v-model="data.STDSCH"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="សាលារៀនគំរូ"
            hide-details
            @keypress.native="onSelect10($event)"
          />          

          <v-select
            class="px-1 ttext"
            v-model="data.losa"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="មានថ្នាក់អនុវិទ្យាល័យដែលស្ថិតក្នុងសាលាបឋមសិក្សា"
            hide-details
            @keypress.native="onSelect3($event)"
          />          
          <v-select
            class="px-1 ttext"
            v-model="data.flsc"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="សាលារៀនបណ្ដែតទឹក"
            hide-details
            @keypress.native="onSelect4($event)"
          >
          </v-select>
          <v-select
            class="px-1 ttext"
            v-model="data.tota"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="សាលារៀនទាំងមូលនៅក្នុងវត្ត"
            hide-details
            @keypress.native="onSelect5($event)"
          >
          </v-select>

          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.ncpa"
            type="number"
            :rules="[rules.required]"
            label="ចំនួនថ្នាក់រៀននៅក្នុងវត្ត"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.ncho"
            type="number"
            :rules="[rules.required]"
            label="ចំនួនថ្នាក់រៀននៅតាមផ្ទះ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.numt"
            type="number"
            :rules="[rules.required]"
            label="ចំនួនព្រះសង្ឃដែលជួយបង្រៀននៅក្នុងសាលារៀន"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.nurt"
            type="number"
            :rules="[rules.required]"
            label="ចំនួនគ្រូក្រៅក្របខ័ណ្ឌទទួលប្រាក់ឧបត្ថម្ភពីសហគមន៍/អង្គការនានា"
          />
          <v-select
            class="px-1 ttext"
            v-model="data.papr"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="មានថ្នាក់មត្តេយ្យរដ្ឋដែលស្ថិតក្នុងសាលាបឋមសិក្សា"
            hide-details
            @keypress.native="onSelect6($event)"
          >
          </v-select>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.dsco"
            type="number"
            :rules="[rules.required]"
            label="ចម្ងាយពីសាលារៀនទៅសាលាឃុំ/សង្កាត់"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.dsdi"
            type="number"
            :rules="[rules.required]"
            label="ចម្ងាយពីសាលារៀនទៅសាលាក្រុង/ស្រុក/ខណ្ឌ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.dspr"
            type="number"
            :rules="[rules.required]"
            label="ចម្ងាយពីសាលារៀនទៅសាលារាជធានី/ខេត្ត"
          />

          <v-select
            class="px-1 ttext"
            v-model="data.ansc"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="សាលារៀនឧបសម្ព័ន្ធ"
            hide-details
            @keypress.native="onSelect7($event)"
          >
          </v-select>

          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.encl"
            label="ឈ្មោះកម្រងសាលារៀន(បំពេញជាឡាតាំង)"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.khcl"
            label="ឈ្មោះកម្រងសាលារៀន(បំេពញជាខ្មែ)"
          />

          <v-select
            class="px-1 ttext"
            v-model="data.cosc"
            :items="coreSat"
            item-text="text"
            item-value="value"
            outline
            label="សាលារៀនបង្គោលជាប្រធានកម្រង ឬសាលារៀនសម្ព័ន្ធ"
            hide-details
            @keypress.native="onSelect8($event)"
          >
          </v-select>
          <!-- Allow only negative value -->
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.nuco"
            type="number"
            oninput="if(this.value < 0) this.value = 0;"
            :rules="[rules.required]"
            label="បើជាសាលារៀនបង្គោលសូមប្រាប់ចំនួនសាលារៀនក្នុងកម្រង"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { location, yesNo, yesNo7, numShift } from "@/utils/ascf/commonConfig.js";
import { coreSat } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "title", "info"],
  data() {
    return {
      yesNo: yesNo,
      yesNo7: yesNo7,
      loc: location,
      numShift: numShift,
      coreSat: coreSat,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    onSelect1: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.loc_code = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        // 3options
        this.data.nush = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.losa = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.flsc = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect5: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.data.tota = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect6: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.papr = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect7: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.ansc = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect8: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.data.cosc = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect9: function (event) {
      // Type_care services
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        // 4 options
        this.data.BDXID = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect10: function (event) {
      // Type_care services
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        // 4 options
        this.data.STDSCH = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>